<template>
  <div class="info-region-container">
    <div class="all-content-container">
      <div class="container1">
        <div class="titlemaun">
          <div class="div-h3">
            <h3>添加大棚告警</h3>
          </div>
          <div class="div-button" style="margin-right: 2.5rem;">
            <el-button type="primary" @click="handleAdd">添加大棚告警</el-button>

          </div>
        </div>
        <div class="div-step">
          <el-steps :active="6" align-center>
            <el-step title="添加决策模型"></el-step>
            <el-step title="关联环境模型"></el-step>
            <el-step title="关联生长模型"></el-step>
            <el-step title="绑定城市"></el-step>
            <el-step title="绑定摄像头"></el-step>
            <el-step title="添加设备调控"></el-step>
            <el-step title="添加大棚告警"></el-step>
          </el-steps>
        </div>
      </div>
      <div class="container1">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <!-- <el-form-item label="大棚名称：">
            <el-cascader
              expand-trigger="hover"
              v-model="groupIdArr"
              :options="groupArray"
              :props="optionProps"
              @change="groupChange"
              placeholder="请选择大棚名称"
              collapse-tags
              clearable
            ></el-cascader>
          </el-form-item> -->
          <el-form-item>
            <el-button type="primary" class="button" @click="handleSearch">查询</el-button>
            <el-button type="button" ass="button" @click="handleRest">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="info-content-container">
        <div class="table_content1" style="margin-top: 10px">
          <el-table :data="tableData" align="center" class="data-table" v-loading="loading" style="width: 100%" :header-cell-style="{ background: '#F4F5F7' }">
            <el-table-column align="center" label="大棚名称">
              <template slot-scope="scope">
                <p>{{ scope.row.groupName }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="告警名称">
              <template slot-scope="scope">
                <p>{{ scope.row.alarmName }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="告警类型">
              <template slot-scope="scope">
                <p>{{ scope.row.alarmType }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="告警次数">
              <template slot-scope="scope">
                <p>{{ scope.row.alarmNum }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="次数间隔">
              <template slot-scope="scope">
                <p>{{ scope.row.numInterval }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="告警间隔">
              <template slot-scope="scope">
                <p>{{ scope.row.timeInterval }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="推送模式">
              <template slot-scope="scope">
                <p>{{ topushModel(scope.row.pushModel) }}</p>
              </template>
            </el-table-column>
            <el-table-column fixed="right" align="center" label="操作">
              <template slot-scope="scope">
                <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                <el-button type="text" size="small" @click="handleDel(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="display: flex;justify-content: space-around;">
          <div></div>
          <div class="pagination-container" style="margin-left: 12rem;">
            <div class=" page"></div>
            <div class="pagination-container">
              <div class="page"></div>
              <div class="pagination-content-container">
                <el-pagination background layout="prev, pager, next, jumper" class="pageTap" @current-change="handleCurrentChange" :current-page="searchForm.pageNum" :page-size="searchForm.pageSize" :total="total"></el-pagination>
              </div>
            </div>
          </div>

          <div style="margin-top: 1.3rem;">
            <el-button type="primary" @click="handlePrev">上一步</el-button>
            <el-button disabled style="background-color: #cfe5f8 !important;" class="adduser">下一步</el-button>
            <el-button type="primary" @click="handleReturn">返回决策模型</el-button>
          </div>
        </div>

        <el-dialog :title="addEditTitle" :visible.sync="addEditIsDialog" :before-close="handleCancel" width="600px" center style="z-index: 10000">
          <el-form ref="ruleForm" :rules="rules" :model="ruleForm" label-width="140px" class="demo-ruleForm">
            <!-- <el-row>
              <el-col :span="24">
                <el-form-item label="大棚名称：" prop="groupIdArr">
                  <el-cascader
                    expand-trigger="hover"
                    v-model="ruleForm.groupIdArr"
                    :options="groupArray"
                    :props="optionProps"
                    @change="groupChange2"
                    placeholder="请选择大棚名称"
                    collapse-tags
                    clearable
                  ></el-cascader>
                </el-form-item>
              </el-col>
            </el-row> -->
            <el-row>
              <el-col :span="24">
                <el-form-item label="告警名称：" prop="alarmName">
                  <el-input v-model="ruleForm.alarmName" placeholder="请输入告警名称" maxlength="50" show-word-limit clearable>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="告警类型：" prop="alarmType">
                  <el-input-number placeholder="请输入告警类型" v-model="ruleForm.alarmType" :precision="0" :step="1" :min="0" :max="9999" size="small" style="width: 100%"></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="告警次数：" prop="alarmNum">
                  <el-input-number placeholder="请输入告警次数" v-model="ruleForm.alarmNum" :precision="0" :step="1" :min="0" :max="9999" size="small" style="width: 100%"></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="次数间隔：" prop="numInterval">
                  <el-input-number placeholder="请输入次数间隔" v-model="ruleForm.numInterval" :precision="0" :step="1" :min="0" :max="9999" size="small" style="width: 100%"></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="告警间隔：" prop="timeInterval">
                  <el-input-number placeholder="请输入告警间隔" v-model="ruleForm.timeInterval" :precision="0" :step="1" :min="0" :max="9999" size="small" style="width: 100%"></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="推送模式：" prop="pushModelArr">
                  <el-select v-model="ruleForm.pushModelArr" placeholder="请选择推送模式" multiple collapse-tags clearable @change="pushModelChange">
                    <el-option v-for="item in pushModeloptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="推送人：" prop="pushUserArr">
                  <el-select v-model="ruleForm.pushUserArr" placeholder="请选择推送人" multiple collapse-tags clearable>
                    <el-option v-for="item in pushUserArray" :key="item.id + ''" :label="item.realName + '_' + item.account" :value="item.id + ''">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="handleCancel">取 消</el-button>
            <el-button type="primary" @click="handleSave">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchForm: {
        // 查询条件字段
        pageNum: 1,
        pageSize: 10,
        groupId: ''
      },
      groupIdArr: [],
      total: 0, // 总数
      tableData: [],
      ruleForm: {
        // 添加、编辑弹窗表单
        id: '',
        groupId: '',
        alarmName: '',
        alarmType: '',
        alarmNum: '',
        numInterval: '',
        timeInterval: '',
        pushModel: '',
        pushUserIds: '',
        pushModelArr: [],
        pushUserArr: [],
        groupIdArr: []
      },
      rules: {
        // 添加、编辑弹窗表单规则
        groupIdArr: [
          {
            required: true,
            message: '请选择大棚名称',
            trigger: 'change'
          }
        ],
        alarmName: [
          {
            required: true,
            message: '请输入告警名称',
            trigger: 'blur'
          }
        ],
        alarmType: [
          {
            required: true,
            message: '请输入告警类型',
            trigger: 'blur'
          }
        ],
        alarmNum: [
          {
            required: true,
            message: '请输入告警次数',
            trigger: 'blur'
          }
        ],
        numInterval: [
          {
            required: true,
            message: '请输入次数间隔',
            trigger: 'blur'
          }
        ],
        timeInterval: [
          {
            required: true,
            message: '请输入告警间隔',
            trigger: 'blur'
          }
        ],
        pushModelArr: [
          {
            required: true,
            message: '请选择推送模式',
            trigger: 'change'
          }
        ],
        pushUserArr: [
          {
            required: true,
            message: '请选择推送人',
            trigger: 'change'
          }
        ]
      },
      addEditTitle: '添加大棚告警配置', // 添加编辑弹窗标题
      addEditIsDialog: false, // 添加编辑弹窗是否显示
      pushModeloptions: [
        // 推送模式数组
        {
          value: '0',
          label: '邮箱发送'
        },
        {
          value: '1',
          label: '短信发送'
        },
        {
          value: '2',
          label: 'APP推送'
        },
        {
          value: '3',
          label: '小程序推送'
        },
        {
          value: '4',
          label: '语音拨号提醒'
        }
      ],
      pushUserArray: [], // 推送人集合
      groupArray: [], // 大棚名称数组
      optionProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        checkStrictly: true,
        multiple: false
      }
    }
  },
  created() {
    this.searchForm.groupId = this.$route.query.groupId
    this.ruleForm.groupId = this.$route.query.groupId

    // 获取分组列表
    this.getGroupList()

    // 查询
    this.getList()
  },
  methods: {
    // 查询
    handleSearch() {
      this.searchForm.pageNum = 1
      this.getList()
    },
    // 重置
    handleRest() {
      this.searchForm = {
        pageNum: 1,
        pageSize: 10,
        groupId: this.$route.query.groupId
      }
      this.groupIdArr = []
      this.getList()
    },
    // 分页查询
    handleCurrentChange: function (currentPage) {
      this.searchForm.pageNum = currentPage
      this.getList()
    },
    // 分页获取列表
    getList() {
      this.loading = true
      this.$api.groupAlarm.getGrowthModelGroupAlarmConfigList(this.searchForm).then((res) => {
        if (res.code == 200) {
          this.tableData = res.data
          this.total = res.count
        }
        this.loading = false
      })
    },
    // 删除
    handleDel(row) {
      this.$confirm('是否删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$api.groupAlarm.delGrowthModelGroupAlarmConfig(row.id).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.getList()
            }
          })
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
    // 编辑
    handleEdit(row) {
      this.addEditIsDialog = true
      this.addEditTitle = '编辑大棚告警配置'
      this.ruleForm.id = row.id

      // 获取详情
      this.$api.groupAlarm.getGrowthModelGroupAlarmConfig({ id: row.id }).then((res) => {
        if (res.code == 200) {
          res.data.groupIdArr = [this.getParentGroupId(res.data.groupId), res.data.groupId]
          res.data.pushModelArr = res.data.pushModel ? res.data.pushModel.split(',') : []
          res.data.pushUserArr = res.data.pushUserIds ? res.data.pushUserIds.split(',') : []
          this.ruleForm = res.data

          // 获取推送人列表
          this.getPushUserList()
        }
      })
    },
    // 添加
    handleAdd() {
      this.addEditIsDialog = true
      this.addEditTitle = '添加大棚告警配置'
      this.ruleForm.id = ''
    },
    // 取消
    handleCancel() {
      this.$refs['ruleForm'].resetFields()
      this.addEditIsDialog = false
    },
    // 保存
    handleSave() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.ruleForm.pushModel = this.ruleForm.pushModelArr ? this.ruleForm.pushModelArr.toString() : ''
          this.ruleForm.pushUserIds = this.ruleForm.pushUserArr ? this.ruleForm.pushUserArr.toString() : ''
          this.$api.groupAlarm.saveGrowthModelGroupAlarmConfig(this.ruleForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.handleCancel()
              this.handleSearch()
            }
          })
        }
      })
    },
    // 推送模式改变
    pushModelChange() {
      this.pushUserArray = []
      this.ruleForm.pushUserArr = []

      if (!this.ruleForm.pushModelArr || this.ruleForm.pushModelArr === '' || this.ruleForm.pushModelArr == null) {
        return
      }

      // 获取推送人列表
      this.getPushUserList()
    },
    // 获取推送人列表
    getPushUserList() {
      this.$api.groupAlarm.getSysPushUsers({ pushModel: this.ruleForm.pushModelArr.toString() }).then((res) => {
        if (res.code == 200) {
          this.pushUserArray = res.data
        }
      })
    },
    // 大棚下拉切换
    groupChange() {
      // 不是三级分类
      if (!this.groupIdArr || this.groupIdArr.length != 2) {
        this.groupIdArr = []
        this.searchForm.groupId = ''
      } else {
        this.searchForm.groupId = this.groupIdArr[1]
      }
      this.getList()
    },
    // 大棚下拉切换2
    groupChange2() {
      // 不是三级分类
      if (this.ruleForm.groupIdArr.length !== 2) {
        this.ruleForm.groupIdArr = []
        return
      }
      this.ruleForm.groupId = this.ruleForm.groupIdArr[1]
    },
    // 获取分组列表
    getGroupList() {
      this.$api.system.getGroupList().then((res) => {
        if (res.code == 200) {
          this.groupArray = res.data
        }
      })
    },
    // 获取上级分组id
    getParentGroupId(groupId) {
      let parentGroupId = 0
      let children = []
      this.groupArray.map((item) => {
        if (item.children) {
          children = item.children
          let isEnd = false
          children.every(function (val2) {
            if (val2.id == groupId) {
              parentGroupId = val2.parentId
              isEnd = true
            }
            return val2.id != groupId
          })
          return !isEnd
        }
      })

      return parentGroupId
    },
    // 推送模型转名称
    topushModel(pm) {
      return pm == undefined || pm == null ? '' : pm.toString().replace('0', '邮箱发送').replace('1', '短信发送').replace('2', 'APP推送').replace('3', '小程序推送').replace('4', '语音拨号提醒')
    },
    // 返回
    handleReturn() {
      this.$router.push({
        name: `decisionManagement`,
        query: {}
      })
    },
    // 上一步
    handlePrev() {
      this.$router.push({
        name: `addDeviceControl`,
        query: {
          decisionId: this.$route.query.decisionId,
          groupId: this.$route.query.groupId
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.all-content-container {
  margin: 0 auto;
  width: 100%;
  margin-top: 10px;

  .container1 {
    border: 1px solid rgba(232, 232, 232, 1);
    margin-top: 10px;
  }

  .div-h3 {
    padding: 15px;
  }

  .div-button {
    margin-top: 10px;
    margin-right: 10px;
  }

  .div-step {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .div-footer {
    text-align: center;
    margin-bottom: 50px;
  }

  .titlemaun {
    display: flex;
    justify-content: space-between;
    height: 48px;
    border-bottom: 1px solid #ededed;
  }
}

.demo-ruleForm {
  width: 95%;
  margin: 0 auto;
  padding-top: 10px;

  .el-row {
    margin-bottom: 20px;
  }

  .el-select {
    width: 100% !important;
  }

  .el-input-number {
    width: 100% !important;
  }

  .el-cascader {
    width: 100% !important;
    margin-bottom: 0px !important;
  }
}
</style>